// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import '../../i18n/nl-NL';

import error from './error';

error();
